exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paymentConvenience__text[data-v-7c5b71b4]{font-size:13px;margin:0 0 10px}.paymentConvenience__note[data-v-7c5b71b4]{background:#fff3f7;padding:10px 12px;font-size:12px;line-height:16px;margin:0 0 12px}.paymentConvenience__img[data-v-7c5b71b4]{border:1px solid #d8d8d8;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:10px;padding:20px;margin:0 auto 35px;text-align:center}.paymentConvenience__img>img[data-v-7c5b71b4]{width:100%;vertical-align:middle}.paymentConvenience__notice[data-v-7c5b71b4]{margin:-15px 0 30px;color:#9081c8;font-size:12px;line-height:1.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c5b71b4","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/Academy/partials/PaymentConvenience.vue
// module id = HmGK
// module chunks = 0